import { CrudFilters } from "../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import {
  TableFilterInputWrapper,
  TableFilters,
  TableFiltersWrapper,
} from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { Form, Button } from "react-bootstrap";
import { LicencePlateSelectField } from "../../../general/fields/modules/commons/licencePlateSelectField/licencePlateSelectField";
import { ReactSelectOptionType } from "../../../../shared/types/reactSelectType";

export const EventTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");

  const typeValue = getFilter("type") as string;
  const statusValue = getFilter("status") as string;
  const licencesValue = getFilter("tireset.car.licence", "in");
  const createdAtValue = getFilter("created_at", "between") as unknown as {
    max: string;
    min: string;
  };

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={3}>
          <label>{t("Licence plates")}</label>
          <LicencePlateSelectField
            onChange={(options: unknown) => {
              const selectedOptions = options as ReactSelectOptionType[];
              if (options === null || selectedOptions.length === 0) {
                removeFilter("tireset.car.licence");
                return;
              }

              const selectedOptionsStringArray = selectedOptions.map(
                (option) => {
                  return option.label.replace(/-/g, "").toUpperCase();
                },
              );

              updateFilter(
                "tireset.car.licence",
                selectedOptionsStringArray,
                "in",
              );
            }}
            value={licencesValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("crud.table.events.type")}</label>

          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("type");
              } else {
                updateFilter("type", event.target.value);
              }
            }}
            value={`${typeValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={"APP_LOCATION_SCAN"}>
              {t("event.type.APP_LOCATION_SCAN")}
            </option>
            <option value={"APP_ORDERPICK"}>
              {t("event.type.APP_ORDERPICK")}
            </option>
            <option value={"APP_PACKINGSLIP"}>
              {t("event.type.APP_PACKINGSLIP")}
            </option>
            <option value={"DBB_REQUEST"}>{t("event.type.DBB_REQUEST")}</option>
          </Form.Select>
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("crud.table.events.status")}</label>

          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("status");
              } else {
                updateFilter("status", event.target.value);
              }
            }}
            value={`${statusValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={"NEW"}>{t("event.state.NEW")}</option>
            <option value={"COMPLETED"}>{t("event.state.COMPLETED")}</option>
            <option value={"REJECTED"}>{t("event.state.REJECTED")}</option>
          </Form.Select>
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Date")}</label>
          <Form.Control
            type="date"
            value={createdAtValue?.min ? createdAtValue.min.split("T")[0] : ""}
            onChange={(e) => {
              const date = e.target.value;
              if (e.target.value) {
                updateFilter(
                  "created_at",
                  {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    min: date + "T00:00:00+00:00",
                    max: date + "T23:59:59+00:00",
                  },
                  "between",
                );
              } else removeFilter("created_at");
            }}
          />
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
